/**
 * @module components\ghImage
 */
import Vue from "vue";
import Component from "vue-class-component";
import { Prop } from "vue-property-decorator";
import { API_BASE_URL } from "@/utils/conf";

@Component
export default class GhImage extends Vue {
  @Prop({ default: "" })
  private id!: string;
  @Prop({ default: undefined })
  private aspectRatio!: any;
  @Prop({ default: undefined })
  private height: any;
  @Prop({ default: undefined })
  private width: any;
  @Prop({ default: undefined })
  private maxHeight: any;
  @Prop({ default: "center center" })
  private position: any;
  @Prop({ default: undefined })
  private maxWidth: any;

  private url = API_BASE_URL + "api/files/";

  private get props() {
    return Object.assign({}, this.$props);
  }

  private get src() {
    if (this.id) {
      return this.url + this.id;
    }
    return undefined;
  }
}
